import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Navigation from './home/Navigation';
import Footer from './home/Footer';
import { useSEO } from '../hooks/useSEO';

/** Mise en page des pages légales (mentions, CGV, confidentialité). */
const LegalLayout = ({ titre, description, path, maj = '20 juin 2026', children }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  useSEO({ title: `${titre} | Suro Phone`, description, path });

  return (
    <div className="min-h-screen bg-white" data-testid={`legal-page-${path.replace('/', '')}`}>
      <Navigation isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
      <section className="bg-[#1a2332] text-white py-10 md:py-14 px-4">
        <div className="max-w-3xl mx-auto">
          <nav className="text-sm text-gray-400 mb-3" aria-label="Fil d'Ariane">
            <Link to="/" className="hover:text-white">Accueil</Link> › <span className="text-white">{titre}</span>
          </nav>
          <h1 className="text-3xl md:text-4xl font-bold">{titre}</h1>
          <p className="text-gray-400 text-sm mt-2">Dernière mise à jour : {maj}</p>
        </div>
      </section>
      <article className="max-w-3xl mx-auto px-4 py-10 md:py-14 legal-content">{children}</article>
      <Footer />
    </div>
  );
};

export default LegalLayout;
